import { runbookService } from "../services/runbook.service";
import { runbookConstants } from "../constants/runbook.constants";

export const runbookActions = {
  get,
  create,
  update,
  remove,
  reactivate,
  execute,
  validate,
  cancel,
};

function get(requestParameters) {
  return (dispatch) => {
    dispatch(request(requestParameters));

    runbookService.get(requestParameters).then(
      (response) => {
        dispatch(success(response.data));
      },
      (error) => {
        dispatch(failure());
      }
    );
  };

  function request(requestParameters) {
    return { type: runbookConstants.GET_REQUEST, payload: requestParameters };
  }
  function success(paginatedResult) {
    return { type: runbookConstants.GET_SUCCESS, payload: paginatedResult };
  }
  function failure() {
    return { type: runbookConstants.GET_FAILURE };
  }
}

function create(requestParameters) {
  return (dispatch) => {
    dispatch(request(requestParameters));

    runbookService.create(requestParameters).then(
      (response) => {
        dispatch(success());
      },
      (error) => {
        dispatch(failure());
      }
    );
  };

  function request(requestParameters) {
    return {
      type: runbookConstants.CREATE_REQUEST,
      payload: requestParameters,
    };
  }
  function success() {
    return { type: runbookConstants.CREATE_SUCCESS };
  }
  function failure() {
    return { type: runbookConstants.CREATE_FAILURE };
  }
}

function update(requestParameters) {
  return (dispatch) => {
    dispatch(request(requestParameters));

    runbookService.update(requestParameters).then(
      (response) => {
        dispatch(success());
      },
      (error) => {
        dispatch(failure());
      }
    );
  };

  function request(requestParameters) {
    return {
      type: runbookConstants.UPDATE_REQUEST,
      payload: requestParameters,
    };
  }
  function success() {
    return { type: runbookConstants.UPDATE_SUCCESS };
  }
  function failure() {
    return { type: runbookConstants.UPDATE_FAILURE };
  }
}

function remove(requestParameters) {
  return (dispatch) => {
    dispatch(request());

    runbookService.remove(requestParameters).then(
      (response) => {
        window.location.reload();
      },
      (error) => {
        dispatch(failure());
      }
    );
  };

  function request() {
    return {
      type: runbookConstants.DELETE_REQUEST,
    };
  }
  function failure() {
    return { type: runbookConstants.DELETE_FAILURE };
  }
}

function reactivate(requestParameters) {
  return (dispatch) => {
    dispatch(request(requestParameters));

    runbookService.reactivate(requestParameters).then(
      (response) => {
        dispatch(success(response.data));
      },
      (error) => {
        dispatch(failure(error));
      }
    );
  };

  function request(requestParameters) {
    return {
      type: runbookConstants.REACTIVATE_REQUEST,
      payload: requestParameters,
    };
  }
  function success(response) {
    return { type: runbookConstants.REACTIVATE_SUCCESS, payload: response };
  }
  function failure(error) {
    // The API returns 401 with a plain-string body when the runbook isn't the
    // caller's (cross-tenant / not found), so fall back gracefully rather than
    // rendering an object.
    const data = error?.response?.data;
    const message =
      (typeof data === "string" && data) ||
      data?.detail ||
      data?.title ||
      "Reactivation failed. You may not have access to that runbook.";
    return { type: runbookConstants.REACTIVATE_FAILURE, payload: message };
  }
}

function execute(requestBody) {
  return (dispatch) => {
    dispatch(request(requestBody));

    runbookService.execute(requestBody).then(
      (response) => {
        dispatch(success(response.data));
      },
      (error) => {
        dispatch(failure(error));
      }
    );
  };

  function request(requestBody) {
    return {
      type: runbookConstants.EXECUTE_REQUEST,
      payload: requestBody,
    };
  }
  function success(response) {
    return { type: runbookConstants.EXECUTE_SUCCESS, payload: response };
  }
  function failure(error) {
    return {
      type: runbookConstants.EXECUTE_FAILURE,
      payload: error.response.data.title,
    };
  }
}

function validate(requestBody) {
  return (dispatch) => {
    dispatch(request(requestBody));

    runbookService.validate(requestBody).then(
      (response) => {
        dispatch(success(response.data));
      },
      (error) => {
        dispatch(failure(error));
      }
    );
  };

  function request(requestBody) {
    return {
      type: runbookConstants.VALIDATE_REQUEST,
      payload: requestBody,
    };
  }
  function success(response) {
    return { type: runbookConstants.VALIDATE_SUCCESS, payload: response };
  }
  function failure(error) {
    return {
      type: runbookConstants.VALIDATE_FAILURE,
      payload: error.response.data.title,
    };
  }
}

function cancel(requestBody) {
  return (dispatch) => {
    dispatch(request(requestBody));

    runbookService.cancel(requestBody).then(
      (response) => {
        dispatch(success(response.data));
      },
      (error) => {
        dispatch(failure(error));
      }
    );
  };

  function request(requestBody) {
    return { type: runbookConstants.CANCEL_REQUEST, payload: requestBody };
  }
  function success(response) {
    return { type: runbookConstants.CANCEL_SUCCESS, payload: response };
  }
  function failure(error) {
    return {
      type: runbookConstants.CANCEL_FAILURE,
      payload: error?.response?.data?.detail || error?.response?.data?.title,
    };
  }
}
